var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-xl h-40 bg-center bg-no-repeat bg-cover category-card mr-4 lg:mr-6 relative flex items-end cursor-pointer pulse"},[_c('div',{staticClass:"rounded-xl absolute inset-0 flex items-end p-5 purple-gradiant"})])
}]

export { render, staticRenderFns }